/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserRoles } from '@scenario/models/user-roles.model';

export class UserRolesMapper {
  mapToDomainModel(dto: any): UserRoles {
    return {
      roles: Array.isArray(dto) ? dto : (dto.roles ?? []),
    };
  }
}
